/** @file deleteKeysCommand: one clip.setKeys that removes some nodes' keys (empty keys vanish). */
import type { Command } from '@zilo/pose3d-commands/types/command';
import type { Clip, ClipKey } from '@zilo/pose3d-format/types/clip';

/**
 * `clip.setKeys` `replace` with every affected key rewritten without the listed nodes (a key left with no nodes and
 * no events is deleted by the command); null when none of `keys` exists.
 */
export function deleteKeysCommand(clipName: string, clip: Pick<Clip, 'keys'>, keys: { node: string; frame: number }[]): Command | null {
  const out: ClipKey[] = [];
  for (const key of clip.keys) {
    const drop = new Set(keys.filter((k) => k.frame === key.frame && k.node in key.nodes).map((k) => k.node));
    if (drop.size === 0) continue;
    out.push({ ...key, nodes: Object.fromEntries(Object.entries(key.nodes).filter(([n]) => !drop.has(n))) });
  }
  return out.length === 0 ? null : { name: 'clip.setKeys', input: { clip: clipName, keys: out, merge: 'replace' } };
}
